import React from "react";

import { StyledTie } from "./styles";
import { IProps } from "./interfaces";
import { barlineWidth, signatureWidth } from "../../parameters";

const Tie = ({ width, direction, stick, tiedThroughTimeSignature, isLastNote, barlineType }: IProps) => {
    let realWidth = width +
        (tiedThroughTimeSignature ? signatureWidth : 0) +
        (isLastNote ? barlineWidth[barlineType] : 0) +
        ((isLastNote && barlineType.includes("Both") || barlineType.includes("Start")) ? 14 : 0);
    let height = Math.min(30, realWidth / 5);
    return (
        <StyledTie
            style={{
                position: "absolute",
                top: (direction === "up" ? 10 : -10) + (stick ? 8 : 0),
                left: 15,
                transform: `scale(1, ${direction === "up" ? 1 : -1})`,
                transformOrigin: "top",
            }}
        >
            <svg width={realWidth} height="23">
                <path
                    d={`M 2 0 Q ${realWidth / 2} ${height} ${realWidth - 2} 0 L${realWidth} 0 Q ${realWidth / 2} ${
                        height + 7
                    } 0 0 L 2 0`}
                />
            </svg>
        </StyledTie>
    );
};

export default Tie;
